import React from 'react';
import {
  Backdrop,
  Typography,
} from '@material-ui/core';
import { SentimentVeryDissatisfiedOutlined } from '@material-ui/icons';

import styles from './styles.scss';

const UnsupportedBrowser = () => (
  <Backdrop className={styles.backdropWrapper} open>
    <Typography color='error' variant='h2'>
      <SentimentVeryDissatisfiedOutlined fontSize='inherit' />
    </Typography>
    <Typography color='error' variant='h4'>
      Unsupported browser
    </Typography>
    <Typography className={styles.copy} variant='body1'>
      Unfortunately, this browser does not support the use of your device’s microphone or camera.
    </Typography>
    <Typography className={styles.copy} variant='body1'>
      TeleConsult currently supports all modern desktop browsers, Android mobile browsers, and iOS Safari.
    </Typography>
  </Backdrop>
);

export default UnsupportedBrowser;
